import React, { useCallback, useState } from "react";
import { css } from "glamor";
import Spinner from "../library/Spinner";
import FinanceHelpSection from "./FinanceHelpSection";
import PurchaseRow, { PaginationBar, PurchaseTableHeader } from "./PurchaseRow";
import PurchaseDetailsModal from "./PurchaseDetailsModal";
import { findInvoiceLink } from "./financePurchasesHelpers";

const containerClass = css({
  display: "flex",
  flexDirection: "column",
  gap: 10,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  fontFamily: "Montserrat, sans-serif",
});

const panelClass = css({
  width: "100%",
  minWidth: 0,
  background: "#FFFFFF",
  border: "0.6px solid #E2E8F0",
  borderRadius: 10,
  overflow: "hidden",
});

const emptyClass = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "40px 24px",
  fontSize: 14,
  color: "#64748B",
  textAlign: "center",
});

export default function FinancePurchasesList({
  purchases = [],
  loading,
  pagination,
  invoices = [],
  page,
  onPageChange,
  currentUser,
}) {
  const [selectedPurchase, setSelectedPurchase] = useState(null);

  const handleSelect = useCallback((purchase) => setSelectedPurchase(purchase), []);
  const handleCloseModal = useCallback(() => setSelectedPurchase(null), []);

  const selectedInvoiceLink = selectedPurchase ? findInvoiceLink(selectedPurchase, invoices) : null;

  if (loading) {
    return <Spinner wrapped text="Carregando compras..." />;
  }

  return (
    <div className={containerClass}>
      <div className={panelClass}>
        {purchases.length === 0 ? (
          <div className={emptyClass}>Nenhuma compra encontrada.</div>
        ) : (
          <>
            <PurchaseTableHeader />

            {purchases.map((purchase) => (
              <PurchaseRow
                key={purchase.id}
                purchase={purchase}
                invoices={invoices}
                onSelect={handleSelect}
              />
            ))}

            <PaginationBar
              page={page}
              totalPages={pagination?.totalPages || 1}
              onPageChange={onPageChange}
            />
          </>
        )}
      </div>

      <FinanceHelpSection currentUser={currentUser} />

      <PurchaseDetailsModal
        purchase={selectedPurchase}
        invoiceLink={selectedInvoiceLink}
        onClose={handleCloseModal}
      />
    </div>
  );
}
